const QuestionReferenceImage = ({ surveyRoute, dimensionIndex, questionIndex }) => {
  const referenceImage =
    require(`../../assets/img/reference_images/${surveyRoute}/${dimensionIndex}/${questionIndex}.jpg`).default;
  return (
    <img
      alt={`Reference image question ${dimensionIndex} ${questionIndex}`}
      src={referenceImage}
      className="img-fluid pt-2 pb-4"
    />
  );
};

export default QuestionReferenceImage;
